import "styled-components"
import styled, { css, ThemeProvider, useTheme } from "~ui/styled"
import { Dimensions } from "~ui"

const { width, height } = Dimensions.get("window")
export const scale = height / width

// ---------- 尺寸系统 ----------
export const fontSizes = {
  xs: "10px",
  sm: "12px",
  md: "14px",
  lg: "16px",
  xl: "18px",
  "2xl": "20px",
  "3xl": "24px",
  "4xl": "28px",
  "5xl": "32px",
} as const

export const space = {
  0: "0px",
  xs: "4px",
  sm: "8px",
  m: "12px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  "2xl": "40px",
  "3xl": "48px",
} as const

export const radii = {
  none: "0px",
  xs: "2px",
  sm: "4px",
  md: "6px",
  lg: "8px",
  xl: "12px",
  "2xl": "16px",
  "3xl": "20px",
  full: "9999px",
} as const

// ---------- 主题类型 ----------
export interface Theme {
  window: {
    width: number
    height: number
    scale: number
  }
  schema: string
  colors: {
    primary: string
    secondary: string
    success: string
    warning: string
    danger: string
    error: string
    background: string
    blockBackground: string
    grayBackground: string
    buttonBackground: string
    purpleBackground: string
    inputBackground: string
    inputPlaceholderColor: string
    border: string
    mask: string
    text: string
    infoText: string
    warningText: string
    primaryText: string
    secondaryText: string
    textLight: string
  }
  fontSizes: typeof fontSizes
  space: typeof space
  radii: typeof radii
}

// ---------- 主题内容 ----------
export const lightTheme: Theme = {
  window: { width, height, scale },
  schema: "light",
  colors: {
    primary: "#07c160",
    secondary: "#7e8392",
    success: "#97c21c",
    warning: "#f59a23",
    danger: "#fa5251",
    error: "#fa5251",
    background: "#f7f7f7",
    blockBackground: "#fff",
    grayBackground: "#f2f2f6",
    buttonBackground: "#07c160",
    purpleBackground: "#c332d0",
    inputBackground: "#cccccc1c",
    inputPlaceholderColor: "#a2a8af",
    border: "#e3e6ec",
    mask: "rgba(0, 0, 0, 0.4)",
    text: "#303943",
    infoText: "#a2a8af",
    warningText: "#fa7e51",
    primaryText: "#4e98f3",
    secondaryText: "#a2a8af",
    textLight: "#fff",
  },
  fontSizes,
  space,
  radii,
}

export { css, ThemeProvider, useTheme }
export default styled
